import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=54a64f3e&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=54a64f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a64f3e",
  null
  
)

export default component.exports